import { render, staticRenderFns } from "./SmartGuard.vue?vue&type=template&id=71135302&scoped=true"
import script from "./SmartGuard.vue?vue&type=script&lang=js"
export * from "./SmartGuard.vue?vue&type=script&lang=js"
import style0 from "./SmartGuard.vue?vue&type=style&index=0&id=71135302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71135302",
  null
  
)

export default component.exports